<!-- Modal -->
<div class="modal fade" id="exampleModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLongTitle">{{ ModalTitle }}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="CloseClick()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <app-add-edit-attendance
          [attend]="attend"
          [empId] = "empId"
          *ngIf="activateAddEditAttendance">
        </app-add-edit-attendance>
      </div>
    </div>
  </div>
</div>



<div class="col-md-12">
  <div class="card" style="border-radius: 0.5rem">
    <div class="card-body">
      <div class="row">
        <div class="col-md-12">
          <div class="container-fluid my-4">

            <div>
              <h2 *ngIf="employeeName">
                {{ employeeName }}'s
                Attendance record
              </h2>

              <!-- Button trigger modal -->
              <button type="button" class="btn btn-outline-success float-right m-2" data-toggle="modal"
                data-target="#exampleModalCenter" (click)="AddClick()" data-backdrop="static" data-keyboard="false">
                <i class="fas fa-folder-plus fa-lg"></i>
                Add Attendance Record
              </button>
            </div>

            <table class="table table-striped table-sm table-hover" style="height: 500px; overflow: scroll">
              <thead class="thead-dark">
                <tr>
                  <th>Date</th>
                  <th>Arrival</th>
                  <th>Departure</th>
                  <th>Duration</th>
                  <th>Options</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let DataItem of attendanceList">
                  <td>{{ DataItem.Date | date: 'mediumDate' }}</td>
                  <td>{{ DataItem.Arrival}}</td>
                  <td>{{ DataItem.Departure}}</td>
                  <td>{{ DataItem.DurationOfTasks/3600 | number: '1.2-2' }}</td>
                  <td>
                    <!-- <button type = "button"
                    class = "btn btn-light mr-1 btn-sm border-0"
                    (click) = "EditClick(DataItem)"
                    data-toggle="tooltip" placement="top"
                    ngbTooltip="Edit this attendance record">
                    <i class="fas fa-edit"></i>
                </button> -->
                    <button type="button" class="btn btn-outline-dark mr-1 btn-sm border-0"
                      (click)="DeleteClick(DataItem)" data-toggle="tooltip" placement="top"
                      ngbTooltip="Delete this attendance record">
                      <i class="fas fa-trash"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>

          </div>
        </div>
      </div>
    </div>
  </div>
</div>
